import React, { useEffect, useState } from "react";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import Disclamer from "../components/Disclamer";
import Footer from "../components/Footer";

const HomePage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [data, setData] = useState(null);
  const [trackingData, setTrackingData] = useState({
    gclid: null,
    utm_source: null,
    utm_medium: null,
    utm_campaign: null,
    utm_term: null,
  });

  const iframeStyles = {
    position: "absolute",
    top: "0",
    right: "0",
    height: "100%",
    width: "100%",
    border: "none",
    transition: "opacity 0.5s ease-in-out",
    opacity: loading ? 0 : 1,
    zIndex: "999999",
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);

    const gclid = queryParams.get("gclid");
    const utm_source = queryParams.get("utm_source");
    const utm_medium = queryParams.get("utm_medium");
    const utm_campaign = queryParams.get("utm_campaign");
    const utm_term = queryParams.get("utm_term");

    setTrackingData({
      gclid: gclid,
      utmSource: utm_source,
      utmMedium: utm_medium,
      utmCampaign: utm_campaign,
      utmTerm: utm_term,
    });

    if (gclid) {
      setTimeout(() => {
        axios
          .post("https://api.aufantasy.com/api/Cricket", {
            gclid: gclid,
            utmSource: utm_source,
            utmMedium: utm_medium,
            utmCampaign: utm_campaign,
            utmTerm: utm_term,
          })
          .then((response) => {
            setData(response.data);
            setError(response.status === 207);
            
            setTimeout(() => {
              setLoading(false);
            }, 2000); 
          })
          .catch((error) => {
            setError(true);
            
           
            setTimeout(() => {
              setLoading(false);
            }, 2000);
          });
      }, 1000); 
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 2000); 
    }
  }, []);

  if (loading) {
    return (
      <div
        style={{
          margin: "0px",
          padding: "0px",
          height: "100vh", 
          width: "100vw", 
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <ClipLoader
          color="#36d7b7"
          size={80}
          cssOverride={{
            
          }}
        />
      </div>
    );
  }

  if (error && data) {
    return (
      <div
        style={{
          margin: "0px",
          padding: "0px",
          height: "100vh", 
          width: "100vw", 
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          position: "relative"
        }}
      >
        {loading && (
          <ClipLoader
            color="#36d7b7"
            size={80}
            cssOverride={{
              zIndex: "9999999"
            }}
          />
        )}
        <iframe
          style={iframeStyles}
          src={data}
          title="Full Page iFrame"
        ></iframe>
      </div>
    );
  }

  return (
    <>
      <Header />
      <Hero />
      <About />
      <Disclamer />
      <Footer />
    </>
  );
};

export default HomePage;